export enum GroupInvitationStatus {
  Unknown = "Unknown",
  Declined = "NotGoing",
  Maybe = "Maybe",
  Accepted = "Going"
}

export enum GroupStatusColor {
  Green = "green",
  Gold = "gold",
  Red = "red",
  Black = "black"
}

export enum BackendGroupInvitationStatus {
  Unknown = 0,
  Declined = 1,
  Maybe = 2,
  Accepted = 3
}